import { ChartConfig } from '@blisspointmedia/bpm-types/dist/dashboarding';
import { canonicalize } from '../../utils/data';

// The subset of a ChartConfig that DEFINES the chart — what a save persists and what the "Unsaved
// changes" chip must react to. Deliberately EXCLUDES `id` and `version`: the server injects/echoes
// those, so a round-tripped saved config differs from a freshly-emitted working copy on them even when
// nothing meaningful changed (the exact unreliable-signal the chip must avoid). `type` and `title` are
// included — switching line→bar or renaming IS an unsaved edit worth flagging.
const definingSubset = (config: ChartConfig) => ({
  type: config.type,
  title: config.title,
  queries: config.queries,
  merge: config.merge,
  comparison: config.comparison,
  encoding: config.encoding,
  controls: config.controls
});

// True when two ChartConfigs describe DIFFERENT charts (ignoring id/version + key order). Drives the
// "Unsaved changes" chip: a working copy that canonically equals the saved config shows no chip.
export const configsDiffer = (a: ChartConfig, b: ChartConfig): boolean =>
  JSON.stringify(canonicalize(definingSubset(a))) !==
  JSON.stringify(canonicalize(definingSubset(b)));
